/// <reference path="../typings/index.d.ts" />

declare var Chart: any;
namespace App {

  export class ChartJs {
    public static MONTHS = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];


    public months(config: any) {
      var cfg = config || {};
      var count = cfg.count || 12;
      var section = cfg.section;
      var values = [];
      var i, value;

      for (i = 0; i < count; ++i) {
        value = ChartJs.MONTHS[Math.ceil(i) % 12];
        values.push(value.substring(0, section));
      }

      return values;
    }

    public inicializarCampo(id: string, data: any, text: string, formatDataLabels: any = null): any {
      var elemento = document.getElementById(id);
      var objChart = new Chart(elemento, {
        type: 'bar',
        data: data,
        options: {
          legend: false,
          tooltip: false,
          tooltips: {
            enabled: false
          },
          showTooltips: false,
          hover: { mode: null },
          plugins: {
            datalabels: {
              align: function (context: any) {
                var index = context.dataIndex;
                var value = context.dataset.data[index];
                var invert = Math.abs(value) <= 1;
                return value < 1 ? 'end' : 'start'
              },
              anchor: 'end',
              backgroundColor: null,
              borderColor: null,
              borderRadius: 4,
              borderWidth: 1,
              color: '#404244',
              font: {
                size: 10,
                weight: 600
              },
              offset: 4,
              padding: 0,
              formatter: formatDataLabels ? formatDataLabels : function (value: any) {
                return value ? value.toLocaleString('pt-BR') : 0;
              }
            }
          }
        }
      });
      return objChart;
    }
  }
}


